import { render, staticRenderFns } from "./CarouselInformation.vue?vue&type=template&id=848edf3a&scoped=true"
import script from "./CarouselInformation.vue?vue&type=script&lang=js"
export * from "./CarouselInformation.vue?vue&type=script&lang=js"
import style0 from "./CarouselInformation.vue?vue&type=style&index=0&id=848edf3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848edf3a",
  null
  
)

export default component.exports